<mat-card class="suppliers-card">
  <div class="card-container">
    <h3 class="card-title">{{ title }}</h3>

    @if (data().total > 0) {
      <div class="content-row">
        <!-- SVG Диаграмма -->
        <div class="chart-section">
          <svg viewBox="0 0 240 240" class="donut-svg">
            @for (item of data().items; track $index) {
              <path
                [attr.d]="describeArc(120, 120, 60, item.startAngle, item.endAngle)"
                [attr.stroke]="item.color"
                stroke-width="20"
                fill="none"
                stroke-linecap="round"
              />

              <!-- Процент на сегменте -->
              @if (item.pct >= 5) {
                <text
                  [attr.x]="getLabelPosition(item, 60, 120, 120).x"
                  [attr.y]="getLabelPosition(item, 60, 120, 120).y"
                  text-anchor="middle"
                  dominant-baseline="central"
                  class="segment-label"
                >
                  {{ item.pct | number: '1.0-0' }}%
                </text>
              }
            }

            <!-- Центр: 100% -->
            <text
              x="120"
              y="120"
              text-anchor="middle"
              dominant-baseline="central"
              class="center-label"
            >
              100%
            </text>
          </svg>
        </div>

        <!-- Легенда -->
        <div class="legend-section">
          <!-- Всего распределено -->
          <div class="legend-row total">
            <div class="legend-label secondary">{{ 'dashboard.allocated' | translate }}</div>
            <div class="legend-value">
              {{ kgToTons(data().total) }}
              <span class="legend-percentage">(100%)</span>
            </div>
          </div>

          <!-- Список поставщиков -->
          @for (item of data().items; track $index) {
            <div class="legend-row">
              <div class="legend-label">
                <span class="legend-dot" [style.background]="item.color"></span>
                <span class="legend-name">{{ item.name }}</span>
              </div>
              <div class="legend-value">
                {{ kgToTons(item.value) }}
                <span class="legend-percentage">
                  ({{ item.pct | number: '1.0-0' }}%)
                </span>
              </div>
            </div>
          }
        </div>
      </div>
    } @else {
      <!-- Нет данных -->
      <div class="no-data-container">
        <div class="no-data-message">{{ 'dashboard.noData' | translate }}</div>
      </div>
    }
  </div>
</mat-card>
